export const version = "hdnode/5.8.0";
//# sourceMappingURL=_version.js.map